import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#8bb93e',
        secondary: '#b0bec5',
        accent: '#8bb93e',
        success: '#8bb93e',
        error: '#b71c1c'
      }
    }
  },
  icons: {
    iconfont: 'mdi' // default - only for display purposes
  }
})
